import { FC, ReactNode } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { SxProps } from '@mui/material/styles';

import disabledIcon from '../../../icons/Vehicles/car/Disabled.svg?url';
import {
	LoadingContentWrapper,
	SkeletonContainer,
	SkeletonIconWrapper,
} from '../RideHailingService.styles';

export interface RideHailingServiceSkeletonProps {
	icon?: ReactNode;
	/**
	 * Number of skeleton rows to display (2 for MyWay, 3 for LBT with labels)
	 * @default 2
	 */
	rows?: 2 | 3;
	sx?: SxProps;
	testId?: string;
}

const skeletonStyle = {
	borderRadius: '80px',
	background: 'linear-gradient(90deg, #F3F3F3 0%, #EAEAEA 100%)',
};

export const RideHailingServiceSkeleton: FC<
	RideHailingServiceSkeletonProps
> = ({ icon, rows = 2, sx, testId = 'ride-hailing-service-skeleton' }) => {
	return (
		<SkeletonContainer sx={sx} data-testid={testId}>
			<Stack spacing={1.5} width="100%">
				<LoadingContentWrapper>
					<SkeletonIconWrapper>
						{icon ? (
							typeof icon === 'string' ? (
								<img src={icon} alt="Loading" width={48} height={48} />
							) : (
								icon
							)
						) : (
							<img src={disabledIcon} alt="Loading" width={48} height={48} />
						)}
					</SkeletonIconWrapper>
					<Stack spacing={1.5} flex={1}>
						<Stack direction="row" spacing={1.5} alignItems="center">
							<Skeleton
								variant="rounded"
								width={166}
								height={16}
								sx={skeletonStyle}
							/>
							<Skeleton
								variant="rounded"
								height={16}
								sx={{
									flex: '1 0 0',
									...skeletonStyle,
								}}
							/>
						</Stack>
						<Skeleton
							variant="rounded"
							width={133}
							height={16}
							sx={skeletonStyle}
						/>
					</Stack>
				</LoadingContentWrapper>
				{rows === 3 && (
					<Skeleton
						variant="rounded"
						width={166}
						height={16}
						sx={skeletonStyle}
					/>
				)}
			</Stack>
		</SkeletonContainer>
	);
};
